import { mapState } from 'vuex'

export const commonMixin = {
	computed: {
		...mapState([ 'localization', 'tiles' ])
	},
	methods: {
		getLocale(string){
			if( this.localization.hasOwnProperty(string) ){
				return this.localization[string];
			}else{
				return '';
			}
		},
		getTilePath(shape, data, scale){
			let path = 'M';
			
			shape.forEach((coord, i) => {
				path+= (i!=0 ? 'L':'')+((coord[0]+data[0])*scale)+' '+((coord[1]+data[1])*scale);
			});
			
			return path+'Z';
		},
		getPieSlice(index, total){
			const RADIAN = Math.PI * 2;
			const cx = 12
			const cy = 12;
			const r = 12;
			const step = RADIAN / total;

			const sa = index / total * RADIAN;
			const ea = (index+1) / total * RADIAN;
			const sx = Math.cos( sa ) * r + cx;
			const sy = Math.sin( sa ) * r + cy;
			const ex = Math.cos( ea ) * r + cx;
			const ey = Math.sin( ea ) * r + cy;
			const la = step > Math.PI ? 1 : 0;
			const sw = 1;
			const d = [
				`M ${cx} ${cy}`, 
				`L ${sx} ${sy}`,
				`A ${r} ${r} 0 ${la} ${sw} ${ex} ${ey}`,
				`z` 
			];
			return d.join( '' );
		},
		findTile(tile_id){
			return this.tiles.find( t => t.external_id == tile_id);
		},
		findColor(colors, rgb){
			return colors.find( c => {
				return c.rgb == rgb;
			});
		},
		isCustom(group){
			if(group.colors.length <= 1) return false;
			let c = (group.colors.join()+','+group.types.join()).toLowerCase();
			
			let non_custom = [];
			group.presets.forEach( p => {
				non_custom.push( (p.colors[0]+','+p.colors[1]+','+p.types[0]+','+p.types[1]).toLowerCase() );
				non_custom.push( (p.colors[1]+','+p.colors[0]+','+p.types[1]+','+p.types[0]).toLowerCase() );
			});
			
			return non_custom.indexOf(c) == -1;
		}
	}
}
